"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    amount: zod_1.z.number((0, validation_1.labelZodErrors)("Amount")).optional(),
});
const dataSchema = zod_1.z.object({
    amount: zod_1.z.number((0, validation_1.labelZodErrors)("Amount")).gt(0, "Must be greater than 0."),
});
exports.default = new ItemDefinition_1.ItemDefinition("Amount", configSchema, dataSchema, new validation_1.ValidatorPipeline("Amount Config Validator", []), new validation_1.ValidatorPipeline("Amount Data Validator", []));
//# sourceMappingURL=Amount.js.map